import React from 'react';
import moment from 'moment';
import styles from './OrderSearch.module.scss';
import PropTypes from 'prop-types';
import { SearchBox, SearchItem } from '@/components/Layout';
import { connect } from 'react-redux';
import { XInput, XOKButton, XCancelButton, XSelect, XDatePicker } from '@/components/xqxc_ui';
import model from '@/reducers/aftersale/suggestions/model';
import http from '@/assets/api/http';

const dealStatus = [{ id: '', value: '全部' }, { id: 0, value: '待处理' }, { id: 1, value: '已处理' }];
class OrderSearch extends React.Component {

    state = {
        accountTel: '', // 会员手机
        accountNickname: '', // 会员昵称
        processState: {}, // 状态
        ideaBackCode: {},
        starTime: null, // 充值开始日期
        endTime: null, // 充值结束日期
        suggestionsPort: {}, //  反馈端口
        systemTypeEnum: [],
        systemTypeItem: {}
    }
    componentDidMount() {
        this.props.getfindIdeaBackTypeItem({ enumName: 'IdeaBackCodeEnum' }); // 反馈类型下拉
        this.props.getAccountIdeaBackTypeEnum({ enumName: 'AccountIdeaBackTypeEnum' }); // 用户类型
        http('/?cmd=com.xqxc.api.pig.mis.biz.platform.PfEnumMisService.getEnum', { enumName: 'IdeaBackSystemTypeEnum' }, 'POST')
            .then(res => {
                this.setState({ systemTypeEnum: res.result });
            });
    }
    // 查询
    _searchHandle = () => {
        const { accountTel, accountNickname, ideaBackCode, processState, starTime, endTime, suggestionsPort, systemTypeItem } = this.state;
        const param = {
            accountTel,
            accountNickname,
            ideaBackCode: ideaBackCode.code,
            processState: processState.id,
            starTime,
            endTime,
            appType: suggestionsPort.code == 0 ? undefined : suggestionsPort.code,
            ideaBackSystemType: systemTypeItem.code
        };
        this.props.searchParam(param);
        // console.log(this.state);
    }

    // 重置
    _resetHandle = () => {
        this.setState({
            accountTel: '',
            accountNickname: '',
            ideaBackCode: {},
            processState: {},
            starTime: null,
            endTime: null,
            suggestionsPort: {},
            systemTypeItem: {},
            pageNum: 1,
            pageSize: 10
        });
        this.props.searchParam({});
    }
    startDate = () => {
        this.setState({ endTime: undefined });
    }
    disabledDate = (current) => {
        const { starTime } = this.state;
        let enddays = starTime && moment(starTime);
        return current && current < enddays && enddays.startOf('day');
    }
    render() {
        const { accountTel, ideaBackCode, processState, starTime, endTime, suggestionsPort, systemTypeItem, systemTypeEnum } = this.state;
        const { findIdeaBackTypeItem, AccountIdeaBackTypeEnum } = this.props;
        const index = AccountIdeaBackTypeEnum.findIndex(i => i.code == 0);
        if (index == -1) {
            AccountIdeaBackTypeEnum.unshift({ code: 0, value: '全部' })
        }
        return (
            <div className={styles.container}>
                <SearchBox>
                    <SearchItem>
                        <XSelect
                            label='用户类型'
                            placeholder='请选择用户类型'
                            renderData={AccountIdeaBackTypeEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={suggestionsPort.value}
                            showSearch={true}
                            bindThis={this}
                            bindName='suggestionsPort'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XInput
                            label='手机号'
                            placeholder='请输入手机号'
                            value={accountTel}
                            bindThis={this}
                            bindName='accountTel'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='反馈类型'
                            placeholder='请选择反馈类型'
                            renderData={findIdeaBackTypeItem}
                            dataIndex='value'
                            keyIndex='code'
                            value={ideaBackCode.value}
                            showSearch={true}
                            bindThis={this}
                            bindName='ideaBackCode'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='处理状态'
                            placeholder='请选择处理状态'
                            renderData={dealStatus}
                            dataIndex='value'
                            keyIndex='id'
                            value={processState.value}
                            showSearch={true}
                            bindThis={this}
                            bindName='processState'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XDatePicker
                            label='反馈时间'
                            value={starTime}
                            bindThis={this}
                            bindName='starTime'
                            isFormat
                            showTime={false}
                            defaultTime='00:00:00'
                            onChange={this.startDate}
                        />
                        <div className={styles.timeLine} />
                        <XDatePicker
                            style={{ marginRight: 20 }}
                            label=''
                            value={endTime}
                            bindThis={this}
                            bindName='endTime'
                            isFormat
                            showTime={false}
                            defaultTime='23:59:59'
                            disabledDate={this.disabledDate}
                        />
                    </SearchItem>
                    <SearchItem>
                        <XSelect
                            label='反馈渠道'
                            placeholder='请选择反馈渠道'
                            renderData={systemTypeEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={systemTypeItem.value}
                            bindThis={this}
                            bindName='systemTypeItem'
                        />
                    </SearchItem>
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={this._searchHandle}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={this._resetHandle}
                        />
                    </SearchItem>
                </SearchBox>
            </div>
        );
    }
}

OrderSearch.propTypes = {
    orderState: PropTypes.number,
    searchParam: PropTypes.func,
    getfindIdeaBackTypeItem: PropTypes.func,
    findIdeaBackTypeItem: PropTypes.array,
    getAccountIdeaBackTypeEnum: PropTypes.func,
    AccountIdeaBackTypeEnum: PropTypes.array,

};
const mapStateToProps = (state) => ({
    findIdeaBackTypeItem: state.suggestions.findIdeaBackTypeItem,
    AccountIdeaBackTypeEnum: state.suggestions.AccountIdeaBackTypeEnum,
});
export default connect(mapStateToProps, { ...model.actions })(OrderSearch);